import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { forgotPassword } from "../../services/auth";
// import BottomFooter from "../../components/BottomFooter";
import { toast } from "sonner";

function ForgotPassword() {
  const navigate = useNavigate();

  const { mutate, isPending, isError, error } = useMutation({
    mutationFn: forgotPassword,
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .trim()
        .required("Please enter your email")
        .email("Please enter a valid email address")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Please enter a valid email address",
        ),
    }),
    onSubmit: (values) => {
      let reqData = { ...values };

      mutate(reqData, {
        onSuccess: (data) => {
          console.log(data?.message);
          toast.success(data?.message);

          navigate(`/auth/login?message=${data?.message}`, { replace: true });
        },
        onError: (error) => {
          console.log(error);
          toast.error("Unable to create a user.");
        },
      });
    },
  });

  return (
    <React.Fragment>
      <div className="auth-page-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-7 col-lg-7 col-xl-4">
              <div className="card mt-24 shadow-lg border-0">
                <div className="card-body p-24">
                  {isError && (
                    <div
                      className="alert alert-danger text-sm border-0"
                      role="alert"
                    >
                      {error}
                    </div>
                  )}

                  <div className="text-center mt-2">
                    <h6 className="text-dark mb-1">Forgot Password</h6>
                    <p className="text-muted text-sm">
                      Enter your email to continue to phAMACart.
                    </p>
                  </div>
                  <div className="p-2 mt-24">
                    <form
                      action="#"
                      autoComplete="off"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-16">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className={`form-control ${
                            validation.touched.email &&
                            validation.errors.email &&
                            "is-invalid"
                          }`}
                          id="email"
                          name="email"
                          placeholder="Enter email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                        />
                      </div>

                      <div className="mb-16">
                        <p className="text-gray-500 text-xs">
                          Your personal data will be used to process your order,
                          support your experience throughout this website, and
                          for other purposes described in our
                          <Link
                            to="#"
                            className="text-main-600 text-decoration-underline"
                          >
                            {" "}
                            privacy policy
                          </Link>
                          .
                        </p>
                      </div>
                      <div className="mt-24">
                        <button
                          type="submit"
                          className="btn btn-success w-100"
                          disabled={isPending}
                        >
                          {isPending && (
                            <div
                              className="spinner-border spinner-border-sm me-5"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                          Forget Password
                        </button>
                      </div>

                      <div className="mt-24 text-center">
                        <p className="mb-0">
                          Already have an account ?{" "}
                          <Link
                            className="fw-semibold text-primary text-decoration-underline"
                            to="/auth/login"
                            data-discover="true"
                          >
                            {" "}
                            Signin{" "}
                          </Link>{" "}
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* BottomFooter */}
      {/* <div id="footer">
        <BottomFooter />
      </div> */}
    </React.Fragment>
  );
}

export default ForgotPassword;
